























































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'
import { ItemPontuacaoProfissional } from '@/types/_'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'

@Component
export default class ViewFinanceiroPontuacaoProfissional extends Vue {
  itemPontuacaoProfissionalMode: string = 'CREATE'
  searchProfissional: any = ''
  profissionalName: string = ''

  profissionaisDebounced = _.debounce(param => this.getFinanceiroStore.getProfissionais(param), 500)

  loadEditarItemPontuacaoProfissional: string = ''
  get loadingEditarItemPontuacaoProfissional() { return this.loadEditarItemPontuacaoProfissional }
  set loadingEditarItemPontuacaoProfissional(value: string) { this.loadEditarItemPontuacaoProfissional = value }

  loadSelectProfissional: boolean = false
  get loadingSelectProfissional() { return this.loadSelectProfissional }
  set loadingSelectProfissional(value: boolean) { this.loadSelectProfissional = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemPontuacaoProfissional: boolean = false
  get loadingDeleteItemPontuacaoProfissional() { return this.loadDeleteItemPontuacaoProfissional }
  set loadingDeleteItemPontuacaoProfissional(value: boolean) { this.loadDeleteItemPontuacaoProfissional = value }

  itemToDelete: string = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  loadHistorico: string = ''
  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  get itemsTabelaPontuacaoProfissional() {
    return [
      { text: 'Profissional', value: 'nomeProfissional', align: 'left', sortable: false },
      { text: 'Pontuação', value: 'codigoPontuacao', align: 'left', sortable: false },
      { text: 'Percentual', value: 'percentual', align: 'center', sortable: false },
      { text: 'Equipe profissional', value: 'equipeProfissional', align: 'center', sortable: false },
      { text: 'Hospital', value: 'nomeHospital', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsPontuacaoProfissional() {
    return this.getFinanceiroStore.itemsPontuacaoProfissional
  }

  get equipesMedicas() {
    return this.getFinanceiroStore.equipesMedicas
  }

  get fontesPagadorasList() {
    return this.getFinanceiroStore.fontePagadoras
  }

  get filtroValorPontuacao() {
    return this.getFinanceiroStore.filtroValorPontuacao
  }

  set filtroValorPontuacao(value: string) {
    this.getFinanceiroStore.setFiltroValorPontuacao(value)
  }

  get filtroProfissionalId() {
    return this.getFinanceiroStore.profissionalId
  }

  set filtroProfissionalId(value: string) {
    this.getFinanceiroStore.setProfissionalId(value)
  }

  get filtroHospital() {
    return this.getFinanceiroStore.filtroHospitalId
  }

  set filtroHospital(value: string) {
    this.getFinanceiroStore.setFiltroHospitalId(value)
  }

  get filtroEquipeProfissional() {
    return this.getFinanceiroStore.filtroEquipeProfissional
  }

  set filtroEquipeProfissional(value: string) {
    this.getFinanceiroStore.setFiltroEquipeProfissional(value)
  }

  criarItemPontuacaoProfissional() {
    this.itemPontuacaoProfissionalMode = 'CREATE'
    this.getFinanceiroStore.clearItemPontuacaoProfissional()
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemPontuacaoProfissional', value: true })
  }

  async editarItemPontuacaoProfissional(item: any) {
    this.itemPontuacaoProfissionalMode = 'EDIT'
    this.getFinanceiroStore.clearItemPontuacaoProfissional()
    this.loadingEditarItemPontuacaoProfissional = item.id
    await timeout(500)
    this.getFinanceiroStore.setOriginalItemPontuacaoProfissional({ ...item } as ItemPontuacaoProfissional)
    this.getFinanceiroStore.setItemPontuacaoProfissional({ ...item } as ItemPontuacaoProfissional)
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemPontuacaoProfissional', value: true })
    this.loadingEditarItemPontuacaoProfissional = ''
  }

  async apagarItemPontuacaoProfissional() {
    this.loadingDeleteItemPontuacaoProfissional = true
    const response = await this.getFinanceiroStore.deletePontuacaoProfissional(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteItemPontuacaoProfissional = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.getFinanceiroStore.getPontuacaoProfissionalAll()
    this.loadingDataTable = false
  }

  async getItemsPontuacaoProfissional() {
    this.loadingSelectProfissional = true
    this.getPagina = 1

    const response = await this.getFinanceiroStore.getPontuacaoProfissionalAll()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um erro ao buscar resultados... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingSelectProfissional = false
  }

  get profissionaisExecutantes() {
    return this.getFinanceiroStore.profissionaisExecutantes
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    this.getHistoricoSituacaoStore.setIdForLoadItems(solicitacaoId)
    await this.getHistoricoSituacaoStore.getHistoricoPontuacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  changeProfissionalExecutante(value) {
    if(value){
      this.filtroProfissionalId = value.userId
      this.profissionalName = value.nome
    } else {
      this.profissionalName = ''
      this.filtroProfissionalId = ''
    }

    this.getItemsPontuacaoProfissional()
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getFinanceiroStore.clearItemsPontuacaoProfissional()
    this.getFinanceiroStore.clearItemPontuacaoProfissional()
    await this.getAllItems()
    await this.getFinanceiroStore.getResumoEquipeMedica()
    await this.getFinanceiroStore.getFontePagadoraAll()
    this.$ga.event('financeiro', 'acessar-tabela-pontuacao-profissional', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsTabelaPontuacaoProfissionalTotal / this.getFinanceiroStore.itemsTabelaPontuacaoProfissionalQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsTabelaPontuacaoProfissionalPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsTabelaPontuacaoProfissionalPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getPontuacaoProfissionalAll()
    this.loadingDataTable = false
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getFinanceiroStore.setProfissionaisExecutantes([])
      this.filtroProfissionalId = ''
      return
    }

    if(this.profissionalName === val){
      return
    } else {
      this.filtroProfissionalId = ''
    }
    
    this.loadingSelectProfissional = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingSelectProfissional = false
  }
}
